import { render } from "./chatwithallpatietdoctorView.vue?vue&type=template&id=65e566de&scoped=true"
import script from "./chatwithallpatietdoctorView.vue?vue&type=script&lang=js"
export * from "./chatwithallpatietdoctorView.vue?vue&type=script&lang=js"

import "./chatwithallpatietdoctorView.vue?vue&type=style&index=0&id=65e566de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e566de"]])

export default __exports__